import * as React from 'react';
import { Header, NavMenu } from "./index";

interface IDefaultLayoutProps {
    fullWidth?: boolean;
    children: any;
}

class DefaultLayout extends React.PureComponent<IDefaultLayoutProps, any> {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
    }

    componentWillReceiveProps(nextProps: any) {
    }

    componentDidUpdate(prevProps: any) {

    }

    componentWillUpdate(nextProps: any) {
    }

    componentWillUnmount() {
    }

    render() {
        const { fullWidth } = this.props;

        return <div>
            <Header fullWidth={fullWidth} header={'Trial Management'}></Header>
            <NavMenu fullWidth={fullWidth}></NavMenu>
            {this.props.children}
        </div>
    }
}

export default DefaultLayout;